import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

import FormEngine from "@/components/FormEngine/component";
import { Loading } from "@/components/shared/Loading";
import { useAbilities } from "@/hooks/ability/hooks";

const FormEngineScreen = () => {
  const { cannot, isLoading } = useAbilities();
  const router = useNavigate();

  useEffect(() => {
    if (!isLoading && cannot("MAINTAINER")) {
      router({ to: "/" });
    }
  }, [cannot, isLoading, router]);

  return (
    <Loading isLoading={isLoading}>
      <FormEngine />
    </Loading>
  );
};

export const Route = createFileRoute("/form-engine/")({
  component: () => <FormEngineScreen />,
});
